import React from 'react';

import mixin from 'react-mixin';

import { connectToStore } from 'reflux/decorators/connect_to_store.js';
import { forwardPropsToState } from 'utils/react_utils';

// import DocumentModal from './document_modal.jsx';
import DocumentStoreItem from '../../models/document_store_item';
import DocumentModalIds from '../../constants/document_modal_ids';
import { DocumentActions, DocumentStore } from '../../reflux/document_store';
import { ProcessAPI } from 'lecom-api';
import DocumentActionRoutes from '../../constants/document_action_routes';

const RealizeFlash = window.Flash;

export default class DigitalSignatureModal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { noDigitalSign, waitingForTheSignedDocument, documentUploadedSignature, canceledDigitalSignature, signatureFailure, notPermssionDigitalSign, errorCompatibility, errorDigitalSignature} = this.props.store.digitalSignature;
		let message = '';

		if(noDigitalSign === true){
			message = Realize.i18n.t('template.messages.noDigitalSign');
		}
		else if(waitingForTheSignedDocument === true){
			message =  Realize.i18n.t('template.messages.waitingForTheSignedDocument');
		}
		else if(documentUploadedSignature === true){
			message =  Realize.i18n.t('template.messages.documentUploadedSignature');
		}
		else if(canceledDigitalSignature === true){
			message =  Realize.i18n.t('template.messages.canceledDigitalSignature');
		}
		else if(signatureFailure === true){
			message =  Realize.i18n.t('template.messages.signatureFailure');
		}
		else if(errorCompatibility === true){
			message = Realize.i18n.t('template.messages.errorCompatibility')
		}
		else if(errorDigitalSignature === true){
			message = Realize.i18n.t('template.messages.errorDigitalSignature');
		}
		else if(notPermssionDigitalSign === false){
			message = Realize.i18n.t('template.messages.notPermssionDigitalSign');
		}
		else {
			message = Realize.i18n.t('template.messages.connectingDigitalSignService');
		}

		return (
			<div>
				<h6>{message}</h6>
			</div>
		);
	}
}
